//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ResponsiveImage from '@/components/modules/ResponsiveImage'
import FormContactUs from '@/components/modules/FormContactUs'
// import Social from '@/components/modules/Social'

export default {
	components: {
		// ResponsiveImage
		FormContactUs
	},
	// data() {},
	props: ['data'],
	computed: {},
	mounted() {},
	methods: {}
}

